<template>
  <div class="marquee-text-container" ref="container" :style="containerStyle">
    <div class="sitemessage" ref="message" :style="animationStyle">
      {{text}}
    </div>
  </div>
</template>

<script>

function sleep(ms) {
	return new Promise((resolve, reject) => setTimeout(resolve, ms));
}

export default {
  props: {
    text: String,
    duration: Number,
  },
   watch: {
    async text (val) {
      this.setWidth();
    }
  },
  methods: {
    async setWidth () {
      setTimeout(async () => {
        this.containerStyle = {
          width: 'default',
        }
        await sleep(0)
        this.containerStyle = {
          width: this.$refs.message.clientWidth + 'px',
        }
        await sleep(0)
        if (this.$refs.message.clientWidth > this.$refs.container.clientWidth) {
          this.animationStyle = {
            animation: `${this.duration}s linear 2s infinite forwards floatText, ${this.duration}s linear 2s infinite overflowSet, ${this.duration}s linear ${this.duration * .15 + 2}s infinite overflowUnSet`,
          }
        }
        this.setWidth();
      }, 10)
    }
  },
  data () {
    return {
      containerStyle: {},
      animationStyle: {}
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.sitemessage {
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  min-width:1px;
  position: absolute;
  overflow: hidden;
}

.marquee-text-container {
  max-width: 50vw;
  overflow: hidden;
  position: relative;
  height: 20px;
  width: 100%;
}

.sitemessage:hover {
  animation-play-state: paused;
}
</style>

<style>
@keyframes floatText {
  0% {
    transform: translateX(0%);
    left: 0%;
  }
  5%,
  10% {
    transform: translateX(-100%);
    left: 100%;
  }
  15%, 100% {
    transform: translateX(0%);
    left: 0%;
  }
}

@keyframes overflowUnSet {
  0% {
    overflow: hidden;
    width: 100%;
  }
}

@keyframes overflowSet {
  0% {
    overflow: initial;
    width: auto;
  }
}
</style>
